import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, tap } from "rxjs";
import { VersionInterceptorService } from "src/app/common/services/version-interceptor.service";

@Injectable()
export class VersionInterceptor implements HttpInterceptor {
  private readonly VERSION_HEADER = "X-Backend-Version";
  private previousVersion: string | null = localStorage.getItem("backendVersion");
  private readonly versionInterceptorService = inject(VersionInterceptorService);
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(req).pipe(
      tap((event) => {
        if (event instanceof HttpResponse) {
          const newVersion = event.headers.get(this.VERSION_HEADER);
          if (newVersion && this.previousVersion && newVersion !== this.previousVersion) {
            console.warn(`Backend version changed from ${this.previousVersion} to ${newVersion}, reloading...`);
            this.versionInterceptorService.notifyVersionChange();
          }
          if (newVersion) {
            this.previousVersion = newVersion;
            localStorage.setItem("backendVersion", newVersion);
          }
        }
      }),
    );
  }
}
